/* eslint-disable @typescript-eslint/no-explicit-any */
import { useParams, useSearchParams } from "react-router-dom";
import "./question.scss";
import LoadError from "../components/error";
import { useEffect, useRef, useState } from "react";
import { ApiEndpoint, BrandColors } from "../components/utils";
import axios from "axios";
import { useQuery } from "react-query";
import Loader from "../components/loader";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { BrandButton, BrandButtonWhite } from "../components/form/buttons";
import { BrandInput } from "../components/form/inputs";
import Calculator from "../components/form/calculator";
import NetworkError from "../components/networkError";

interface QuestionDefinition {
  success: boolean;
  questionId: string;
  type: string;
  description: any;
  options: string[];
  isMath: boolean;
  questions: any;
  isPassage?: boolean;
  mathImage?: string;
  passage: any;
}

const QuestionPreview = () => {
  const { examid, questionid } = useParams();
  const [questionData, setQuestionData] = useState<QuestionDefinition>();
  const [fillInValue, setFillinValue] = useState("");
  const previousAnswer = useRef<string | boolean>("");
  const answered = useRef(false);
  const [hasError, setHasError] = useState(false);
  const [queryParameters] = useSearchParams();
  const token = queryParameters.get("token");
  const fetchEnabled = useRef(false);

  const { isLoading, error, refetch } = useQuery(
    "questionPageData",
    async () => {
      if (questionid) {
        const resp = await axios.post(
          ApiEndpoint + "wp-json/satapp-api/v1/getExamQuestion",
          {
            token: token,
            exam_id: examid,
            questionId: questionid,
          }
        );
        if (!resp || !resp.data.success) {
          setHasError(true);
          return;
        }
        setQuestionData(resp.data);
      } else {
        return null;
      }
    },
    {
      enabled: fetchEnabled.current,
    }
  );

  useEffect(() => {
    if (questionid) {
      refetch();
    }
  }, [questionid, refetch]);

  if (!questionid) return <LoadError />;
  if (isLoading) return <Loader />;
  if (error) return <LoadError />;

  return (
    <>
      <div className="questionPage">
        <div>
          <div
            className={
              questionData?.isPassage
                ? "questionContent passage"
                : "questionContent"
            }
          >
            {questionData?.isPassage && (
              <div
                className="passageText"
                dangerouslySetInnerHTML={{
                  __html: questionData?.passage,
                }}
              />
            )}
            <div className="answerWrapper">
              <div className="questionHolder">
                <div className="questionCount">0</div>
                {questionData?.isMath && questionData.mathImage ? (
                  <div
                    className="questionText"
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{
                      __html: `<div><img src="${questionData?.mathImage}" /></div>${questionData?.description}`,
                    }}
                  />
                ) : (
                  <div
                    className="questionText"
                    dangerouslySetInnerHTML={{
                      __html: questionData?.description,
                    }}
                  />
                )}
              </div>

              <div className="questionAnswersHolder">
                {questionData?.type === "multiple" && (
                  <div className="multipleAnswers">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="question-options"
                        name="radio-options"
                        key="radio-options"
                      >
                        {questionData?.options.map((item: any, index: any) => {
                          return (
                            <>
                              <FormControlLabel
                                key={index}
                                value={index}
                                control={
                                  <Radio
                                    sx={{
                                      color: BrandColors.brandGreen,
                                      "&.Mui-checked": {
                                        color: BrandColors.brandGreen,
                                      },
                                    }}
                                    checked={
                                      // eslint-disable-next-line eqeqeq
                                      index == previousAnswer.current &&
                                      previousAnswer.current !== null
                                        ? true
                                        : false
                                    }
                                  />
                                }
                                label={item}
                              />
                            </>
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                  </div>
                )}
                {questionData?.type === "input" && (
                  <div className="inputHolder">
                    <BrandInput
                      onChange={(evt) => {
                        setFillinValue(evt.target.value);
                        answered.current = true;
                      }}
                      id="filled-basic"
                      label="Answer Here"
                      variant="filled"
                      value={fillInValue}
                    />
                  </div>
                )}
              </div>

              <div style={{ display: "flex" }}>
                <div className="submitAnswerHolder">
                  <BrandButton disabled>SUBMIT ANSWER</BrandButton>
                  <BrandButtonWhite style={{ marginTop: "10px" }} disabled>
                    SKIP QUESTION
                  </BrandButtonWhite>
                </div>
              </div>
            </div>
          </div>
        </div>
        {questionData?.isMath && <Calculator />}
      </div>
      <NetworkError open={hasError} />
    </>
  );
};

export default QuestionPreview;
